import { render } from "./swithLanguage.vue?vue&type=template&id=f9a46226"
import script from "./swithLanguage.vue?vue&type=script&lang=js"
export * from "./swithLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__